import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { helpCenterSettingsArticlesViewArticleRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsArticlesViewArticleRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { csmBaseUrlResource } from '@atlassian/jira-router-resources-service-desk-customer-service-csm-base-url/src/services/index.tsx';
import { navigation } from './common/constants.tsx';
import { helpCenterSettingViewArticleAppPageEntryPoint } from './ui/articles-view-article/index.tsx';

export const helpCenterSettingsArticlesViewArticleRouteEntry = createEntry(
	helpCenterSettingsArticlesViewArticleRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.articles-view-article',
		layout: serviceProjectLayout,
		navigation,
		component: ErrorPagesNotFound,

		entryPoint() {
			return fg('jcs_master_flag') ? helpCenterSettingViewArticleAppPageEntryPoint : undefined;
		},

		resources: [...getServiceDeskSettingsResources(), csmBaseUrlResource],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsArticlesViewArticleRouteEntry.tsx',
				whichExportToUse: 'helpCenterSettingsArticlesViewArticleRouteEntry',
			},

			enabled: true,
		},
	}),
);
